import { useEffect } from "react";

const FIELD_SELECTOR = "input, select, textarea";
let autoId = 0;

function nextFieldId(): string {
  autoId += 1;
  return `argus-field-${String(autoId)}`;
}

function controlFor(label: HTMLLabelElement): HTMLElement | null {
  if (label.querySelector(FIELD_SELECTOR)) return null;
  let sibling = label.nextElementSibling;
  while (sibling) {
    if (sibling instanceof HTMLElement && sibling.matches(FIELD_SELECTOR)) return sibling;
    if (sibling instanceof HTMLElement) {
      const nested = sibling.querySelector(FIELD_SELECTOR);
      if (nested instanceof HTMLElement) return nested;
    }
    sibling = sibling.nextElementSibling;
  }
  return null;
}

export function syncFieldLabels(root: ParentNode): void {
  root.querySelectorAll("label").forEach((label) => {
    if (!(label instanceof HTMLLabelElement) || label.htmlFor) return;
    const control = controlFor(label);
    if (!control) return;
    if (!control.id) control.id = nextFieldId();
    label.htmlFor = control.id;
  });
}

export function useAutoFieldLabels(): void {
  useEffect(() => {
    const root = document.getElementById("root") ?? document.body;
    syncFieldLabels(root);
    const observer = new MutationObserver(() => {
      syncFieldLabels(root);
    });
    observer.observe(root, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
    };
  }, []);
}
